var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynnexLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.77 74.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #009ea7;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e73835;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0068b6;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #b72827;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #005293;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #008086;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #211915;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #bebfc0;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #9e9e9f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.38 36.59 31.55 29.9 27.73 36.58 8.62 36.57 22 12.71 41.11 12.71 44.92 20.35 48.74 12.71 67.85 12.71 81.22 36.57 62.11 36.57 58.29 29.91 54.47 36.57 35.38 36.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.4 47.09 76.44 47.09 72.4 53.77 17.19 53.77 13.4 47.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.18 55.67 44.91 55.67 41.07 62.36 21.99 62.36 18.18 55.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.31 45.18 62.13 38.49 81.23 38.49 77.41 45.18 58.31 45.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.53 45.18 27.71 38.49 8.61 38.49 12.43 45.18 31.53 45.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.47 38.49 35.37 38.49 31.55 45.18 58.29 45.18 54.47 38.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "41.11 12.71 31.55 29.9 35.38 36.59 44.92 20.34 41.11 12.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "67.85 12.72 58.31 29.9 62.1 36.57 81.21 36.57 67.85 12.72"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.74 47.09 46.01 53.76 72.49 53.76 76.44 47.09 49.74 47.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.92 55.68 48.76 62.37 67.83 62.36 71.67 55.68 44.92 55.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.49 38.5 50.69 45.16 58.3 45.22 54.49 38.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "81.24 38.5 77.41 45.19 58.31 45.19 62.13 38.5 81.24 38.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "350.66 15.93 340.37 15.93 328.51 32.06 323.68 15.93 312.16 15.93 321.11 37.34 301.79 59.17 311.97 59.17 324.64 42.63 330.51 59.17 342 59.17 332.29 36.32 350.66 15.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "276.89 53.3 279.54 40.6 299.25 40.6 300.6 34.62 280.76 34.62 283.81 22.03 306.9 22.03 308.32 15.93 274.86 15.93 265.31 59.17 299.77 59.17 300.99 53.3 276.89 53.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "254.61 49.73 240.5 15.93 229.69 15.93 220.13 59.17 229.74 59.17 235.96 25.68 249.99 59.17 260.7 59.17 270.25 15.93 260.75 15.93 254.61 49.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "209.65 49.73 195.55 15.93 184.74 15.93 175.28 59.17 184.77 59.17 191.06 25.82 205.04 59.17 215.75 59.17 225.4 15.93 215.8 15.93 209.65 49.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.62 15.93 157.36 35.52 151.91 15.93 140.06 15.93 149.91 44.19 146.6 59.17 156.99 59.17 160.7 42.88 182.05 15.93 171.62 15.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.27,20.37c3.03,0,5.31.77,6.76,2.29.51.53.9,1.14,1.18,1.8h10.09c-.22-3.18-1.35-5.62-3.27-7.08h-.02c-2.58-2.04-6.49-3.11-11.32-3.11-3.77,0-7.42.63-10.56,1.82-3.01,1.14-5.66,2.82-7.26,4.6-1.89,1.89-3.11,4-3.54,6.12-.04.46-.2.87-.31,1.17-.04.12-.11.29-.11.34,0,.36-.03.79-.07,1.2v.13c-.03.19-.04.33-.04.43-.06,2.16.34,5.04,2.58,6.53,2.4,1.84,6.1,3.43,10.44,4.49,3.14.79,5.79,1.75,7.45,2.72,2.38,1.18,3.46,3.79,2.61,6.33-1.03,3.25-4.44,5.12-9.36,5.12-2.09,0-4.37-.62-5.95-1.63-1.29-.9-2.16-2.13-2.63-3.68h-10.18c.04,3,1.09,5.42,3.13,7.18,3,2.39,7.14,3.66,11.97,3.66,5.57,0,10.69-1.18,15.64-3.6,3.91-1.91,6.65-5.65,7.72-10.52.07-.96.19-1.86.26-2.35l.02-.15c.02-.12.03-.18.03-.22.16-2.44-.56-4.25-2.34-5.86-1.9-1.51-5.26-3.03-8.98-4.05-1.49-.46-3.45-1-5.14-1.42-2.62-.75-4.1-1.46-5.1-2.47-1.38-1.18-2.02-3.19-1.59-5.1.28-1.41,1.62-4.72,7.89-4.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynnexLogoDark);
export default __webpack_public_path__ + "static/media/synnex-logo-dark.a360db81c14b0a45651af839d3b4d633.svg";
export { ForwardRef as ReactComponent };